export default "__VITE_ASSET__Fxq61sg1__"